import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ModalDialog } from '@mssgme/ui';
import imgModal from '../../../img/copylink_img.svg';
import styles from './InstaModalDialog.scss';

InstaModalDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
};

export default function InstaModalDialog({ onClose, ...rest }) {
    const { t } = useTranslation('cards');

    const handleClick = (e) => {
        e.preventDefault();
        window.open('https://www.instagram.com/accounts/edit/', '_blank');
        onClose();
    };

    return (
        <ModalDialog className={styles.root} closeButton={false} modal={{ size: 'small' }} onClose={onClose} {...rest}>
            <div className={styles.header}>{t('pageShare.link_copied')}</div>
            <p>{t('pageShare.link_copied_step1')}</p>
            <img src={imgModal} alt="" />
            <p>{t('pageShare.link_copied_step2')}</p>
            <a href="#" onClick={handleClick}>
                {t('pageShare.openInstagram')}
            </a>
        </ModalDialog>
    );
}
